// Leader bio modal for the [leadership_people] grids: a card's "Read bio" (data-leader-open)
// copies its <template> into #leadership-modal, which locks page scroll while open.
(function () {
	var modalRoot = document.getElementById('leadership-modal');
	var modalPanel = modalRoot ? modalRoot.querySelector('.leadership-modal__panel') : null;
	var lastFocus = null;
	var savedScrollY = 0;
	var scrollLockApplied = false;
	var scrollLockListener = null;
	var isClosing = false;

	function isModalScrollTarget(target) {
		if (!modalPanel || !target) {
			return false;
		}

		return modalPanel === target || modalPanel.contains(target);
	}

	function lockScroll() {
		savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
		document.documentElement.classList.add('leadership-modal-open');
		document.body.classList.add('leadership-modal-open');
		scrollLockApplied = true;

		scrollLockListener = function (e) {
			if (isModalScrollTarget(e.target)) {
				return;
			}

			e.preventDefault();
		};

		document.addEventListener('touchmove', scrollLockListener, { passive: false });
		document.addEventListener('wheel', scrollLockListener, { passive: false });
	}

	function unlockScroll() {
		if (!scrollLockApplied) {
			return;
		}

		document.documentElement.classList.remove('leadership-modal-open');
		document.body.classList.remove('leadership-modal-open');

		if (scrollLockListener) {
			document.removeEventListener('touchmove', scrollLockListener);
			document.removeEventListener('wheel', scrollLockListener);
			scrollLockListener = null;
		}

		scrollLockApplied = false;
	}

	function shouldRestoreFocus() {
		if (!window.matchMedia) {
			return true;
		}

		return !window.matchMedia('(hover: none) and (pointer: coarse)').matches;
	}

	function closeModal() {
		if (!modalRoot || modalRoot.getAttribute('data-leader-modal-open') !== 'true' || isClosing) return;

		isClosing = true;
		modalRoot.setAttribute('data-leader-modal-open', 'false');
		modalRoot.setAttribute('data-closing', 'true');
		modalRoot.setAttribute('aria-hidden', 'true');

		var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		function finishClose() {
			modalRoot.removeAttribute('data-closing');
			if (modalPanel) modalPanel.innerHTML = '';
			unlockScroll();
			isClosing = false;

			if (shouldRestoreFocus() && lastFocus && typeof lastFocus.focus === 'function') {
				try {
					lastFocus.focus({ preventScroll: true });
				} catch (_) {
					lastFocus.focus();
				}
			}
		}

		if (reduced || !modalPanel) {
			finishClose();
			return;
		}

		var finished = false;

		function onTransitionEnd(e) {
			if (finished || e.target !== modalPanel || e.propertyName !== 'transform') return;
			finished = true;
			modalPanel.removeEventListener('transitionend', onTransitionEnd);
			finishClose();
		}

		modalPanel.addEventListener('transitionend', onTransitionEnd);
		window.setTimeout(function () {
			if (finished) return;
			finished = true;
			modalPanel.removeEventListener('transitionend', onTransitionEnd);
			finishClose();
		}, 520);
	}

	function openModal(templateId) {
		if (isClosing) return;

		var template = document.getElementById(templateId);
		if (!template || !modalRoot || !modalPanel) return;

		lastFocus = document.activeElement;
		modalPanel.innerHTML = '<button type="button" class="leadership-modal__close" data-leader-close aria-label="Close bio"><span aria-hidden="true">&times;</span></button>';
		modalPanel.insertAdjacentHTML('beforeend', template.innerHTML);
		lockScroll();
		modalRoot.setAttribute('data-leader-modal-open', 'true');
		modalRoot.setAttribute('aria-hidden', 'false');

		try { modalPanel.focus({ preventScroll: true }); } catch (_) { modalPanel.focus(); }
	}

	// The grids are separate blocks on the page, so listen on the document.
	document.addEventListener('click', function (e) {
		var opener = e.target.closest('[data-leader-open]');
		if (!opener) return;

		e.preventDefault();
		openModal(opener.getAttribute('data-leader-open'));
	});

	if (modalRoot) {
		modalRoot.addEventListener('click', function (e) {
			if (modalRoot.getAttribute('data-leader-modal-open') !== 'true') return;

			var isBackdrop = e.target.classList.contains('leadership-modal__backdrop');
			var isCloseControl = e.target.closest('[data-leader-close]');

			if (isBackdrop || isCloseControl) {
				e.preventDefault();
				closeModal();
			}
		});
	}

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') closeModal();
	});
})();
